import styled from '@emotion/styled'
import { FadeInUp } from 'app/components/Common/Animation/FadeInUp'
import { ArrowLeft } from 'app/components/Icons'
import { useVocabularyData } from 'app/utils/vocabulary'
import { Link } from 'gatsby'
import React, { memo, useEffect, useState } from 'react'

export interface Props {
  languageCode: string
  experiencesPageURL?: string
}

export const BackTo = memo(function BackTo({
  languageCode,
  experiencesPageURL,
}: Props) {
  if (!experiencesPageURL) {
    return null
  }

  const [loading, setloading] = useState(true)

  useEffect(() => {
    setTimeout(() => {
      setloading(false)
    }, 2000)
  }, [])

  return (
    <FadeInUp delay={loading ? 1.3 : 0}>
      <Container to={experiencesPageURL}>
        <ArrowLeft />

        {useVocabularyData('all-experiences', languageCode)}
      </Container>
    </FadeInUp>
  )
})

const Container = styled(Link)`
  display: inline-flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.variants.primaryDark};
  font-family: ${({ theme }) => theme.fontFamily.heading};
  font-size: 0.5625rem;
  font-weight: 500;
  letter-spacing: 0.15em;
  line-height: 0.6875rem;
  margin-left: 5vw;
  text-transform: uppercase;
  &:hover {
    svg {
      opacity: 0.2;
    }
  }

  svg {
    width: auto;
    height: 0.375rem;
    fill: ${({ theme }) => theme.colors.variants.primaryDark};
    margin-right: 0.5rem;
    transition: 0.2s ease-in-out;
  }
`
